import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { localizations } from '../localization/localization';
import { TruckModel, TruckProperties } from "../trucks/TruckModels";
import { momentToString } from '../utils/dateUtilities';
import { toCommaDecimal } from '../utils/numberUtils';
import { ApplicationState } from "../store";
import { connect } from 'react-redux';
import * as TruckStore from '../trucks/store/truckStore'
import ZeckitSmallWidget from '../common/ZeckitSmallWidget';
import { getValidLink } from '../utils/uriParsing';
import * as moment from 'moment';
import CompanyActivityMark from "../common/companyActivityMark";
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import emailImg from "../images/email.svg";
import forwardImg from "../images/forward.svg";
import listImg from "../images/list.svg";

interface GoToDetails {
    onGoToTable: (id: TruckModel) => void;
}

interface SendEmailDetails {
    onSendEmailToReporter: (item: TruckModel) => void;
    onSendEmail: (item: TruckModel) => void;
}

interface RouteProps  { 
    trucks: TruckStore.TrucksState
}

const renderProperties = (properties: TruckProperties) => {
    const propertiesArray: string[] = [];

    Object.keys(properties).forEach((value, index) => {
        if (properties[value]) {
            propertiesArray.push(localizations.trucks.properties[value]);
        }
    });
    
    return <span>{propertiesArray.join(", ")}</span>
}

const renderRoutes = (props: any) => {

    const trucks = props.trucks.routes
    let length = 0
    Object.keys(trucks).forEach((value, index) => {
        if (props.destinationCity !== null && trucks[value].to.id === props.destinationCity.id && trucks[value].from.id === props.departureCity.id && trucks[value].to.id === props.destinationCity.id && trucks[value].distance !== null)  {
            length = Math.round(trucks[value].distance)
        }
        
    });
    if (length !== 0) {
        return <span>~ {length.toFixed()} km</span>
    }
    else {
        return <span/>
    } 
}

const renderPrice = (props: any) => {
    const trucks = props.trucks.routes
    let price = 0.00
    let length = 0
    Object.keys(trucks).forEach((value, index) => {
        if (props.destinationCity !== null && trucks[value].from.id === props.departureCity.id && trucks[value].to.id === props.destinationCity.id && trucks[value].distance !== null )  {
            length = Math.round(trucks[value].distance)
            price = props.contractPrice * length
        }
    });
    if (price !== 0.00) {
        return <span>~ {price.toFixed(2)} €</span>
    }
    else {
        return <span/>
    }
}

function pad(num: number) {
  return ("0"+num).slice(-2);
}
function hhmmss(secs: number) {
  let minutes = Math.floor(secs / 60);
  secs = secs%60;
  const hours = Math.floor(minutes/60);
  minutes = minutes%60;
  return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`;
}
function hmin(secs: number) {
  let minutes = Math.floor(secs / 60);
  secs = secs%60;
  const hours = Math.floor(minutes/60);
  minutes = minutes%60;
    
  if (hours < 1) {
    return `${minutes}${localizations.common.min}`;
  }
  return `${hours}${localizations.common.h} ${pad(minutes)}${localizations.common.min}`;
}

const renderTimeEstimate = (props: any) => {
    const trucks = props.trucks.routes
    let length = 0
    let secs = 0
    let formattedTime = ''
    Object.keys(trucks).forEach((value, index) => {
        if (props.destinationCity !== null && trucks[value].from.id === props.departureCity.id && trucks[value].to.id === props.destinationCity.id && trucks[value].distance !== null )  {
          length = Math.round(trucks[value].distance)
          secs = Math.ceil(length / 80 * 3600)
          formattedTime = hmin(secs)
        }
    });
    if (formattedTime !== '') {
        return <span>~ {formattedTime} {localizations.common.speedUsedForCalc}</span>
    }
    else {
        return null
    }
  }

  const renderTimeOfDelivery = (deliveryTime: moment.Moment) => {
      const now = moment();

      let formattedTime = ''
      const currDate = now.format('DD-MM-YYYY');
      const deliDate = deliveryTime.format('DD-MM-YYYY');
      if (currDate === deliDate) {
        const timeDiff = deliveryTime.diff(now);
        if (timeDiff > 0) {
          // duration in hours
          const hours = deliveryTime.diff(now, 'hours');

          // duration in minutes
          const minutes = deliveryTime.diff(now, 'minutes')%60;
          const minutesStr = ("0"+minutes).slice(-2);

          formattedTime = `${localizations.common.left} ~ ${hours}${localizations.common.h} ${minutesStr}${localizations.common.min}`;
          if (hours < 1) {
            formattedTime = `${localizations.common.left} ~ ${minutesStr}${localizations.common.min}`;
          }
        }
        else {
          formattedTime = momentToString(deliveryTime);
        }
      }
      else {
          formattedTime = momentToString(deliveryTime);
      }

      if (formattedTime !== '') {
          return <span>{formattedTime}</span>
      }
      else {
          return null
      }
    }

type TruckRouteProps = TruckModel & RouteProps & SendEmailDetails

const TruckCardTitle = (props: TruckRouteProps) => (
    <table>
        <tbody>
            <tr>
                <td className="title">{localizations.common.reportNumber}</td>
                <td>{props.reportNumber}</td>
            </tr>
            <tr>
                <td className="title">{localizations.units.readyForDelivery}</td>
                <td>{momentToString(props.availableFrom)}</td>
            </tr>
            <tr>
                <td className="title">{localizations.units.timeOfDelivery}:</td>
                <td>{renderTimeOfDelivery(props.availableTo)}</td>
            </tr>
            <tr>
                <td className="title">{localizations.common.pointOfDeparture}:</td>
                <td>{props.departureCity.name}</td>
            </tr>
            <tr>
                <td className="title">{localizations.common.pointOfArrival}:</td>
                <td>{props.destinationCity && props.destinationCity.name}</td>
            </tr>
            <tr>
                <td className="title">{localizations.common.properties}:</td>
                <td>{renderProperties(props.properties)}</td>
            </tr>
            <tr>
                <td className="title">{localizations.trucks.licensePlateNumber}:</td>
                <td>{props.plateNumber}</td>
            </tr>
            <tr>
                <td className="title">{localizations.trucks.carrierCompany}:</td>
                <td>{props.carrierCompany}</td>
            </tr>
            <tr>
                <td className="title">{localizations.common.contractPriceCol}:</td>
                <td>{props.contractPrice ? `${toCommaDecimal(props.contractPrice)} €/km` : ""}</td>
            </tr>
            <tr>
                <td className="title">{localizations.trucks.distance}: </td>
                <td>{renderRoutes(props)}</td>
            </tr>
            <tr>
                <td className="title">{localizations.trucks.time}: </td>
                <td>{renderTimeEstimate(props)}</td>
            </tr>
            <tr>
                <td className="title">{localizations.common.totalPrice}:</td>
                <td>{renderPrice(props)}</td>
            </tr>
            {props.deletedAt ? <tr>
                <td className="title">{localizations.common.deletedAt}:</td>
                <td>{momentToString(props.deletedAt)}</td>
            </tr> : null}
        </tbody>
    </table>
);

const toEmail = (email: string) => <span><a href={"mailto: " + email}>{email}</a><br /></span>

const TransportCoordinatorInfo = (props: TruckModel) => (
    <table>
        <tbody>
            <tr>
                <td className="title">
                    <Grid container direction="row" spacing={8}>
                        <Grid item>
                            <ZeckitSmallWidget businessId={props.company.businessId} maxWidth={32} />
                        </Grid>
                        <Grid item>
                            <CompanyActivityMark isCompany={false} level={props.company.announcementCount} />
                        </Grid>
                    </Grid>
                </td>
                <td>{localizations.common.announcementShortCount} {props.company.announcementCount}</td>
            </tr>
            <tr>
                <td className="title">{localizations.common.companyName}</td>
                <td>{props.company.name}</td>
            </tr>
            <tr>
                <td className="title" style={{ verticalAlign: "top" }}>{localizations.common.organizer}:</td>
                <td >
                    {props.coordinator.firstName} {props.coordinator.lastName} <br />
                    {props.coordinator.contact ? toEmail(props.coordinator.contact.email || "") : null}
                    {props.coordinator.contact && props.coordinator.contact.emailDetails ? <span>{props.coordinator.contact.emailDetails}<br /></span> : null}
                    {props.coordinator.contact ? <span>{props.coordinator.contact.phoneNumber}<br /></span> : null}
                    {props.coordinator.contact && props.coordinator.contact.phoneDetails ? <span>{props.coordinator.contact.phoneDetails}<br /></span> : null}
                </td>
            </tr>
            {props.company.emailContacts.map((item, index) =>
                <tr key={index}>
                    <td className="title" style={{ verticalAlign: "top" }}>{localizations.common.email} {index + 1}:</td>
                    <td>
                        {toEmail(item.email || "")}
                        {item.emailDetails && item.emailDetails.length > 0 ? item.emailDetails : null}
                    </td>
                </tr>
            )}
            {props.company.phoneContacts.map((item, index) =>
                <tr key={index}>
                    <td className="title" style={{ verticalAlign: "top" }}>{localizations.common.phoneNumber} {index + 1}:</td>
                    <td>
                        <span>{item.phoneNumber}<br /></span>
                        {item.phoneDetails && item.phoneDetails.length > 0 ? <span>{item.phoneDetails}</span> : null}
                    </td>
                </tr>
            )}
            {props.company.website ? 
                <tr>
                    <td className="title">{localizations.common.website}:</td>
                    <td><a href={getValidLink(props.company.website)} target="_blank">{props.company.website}</a></td>
                </tr>
            : null}
        </tbody>
    </table>
);
{/* <Grid container direction="row">
    <Grid item>
        <Typography paragraph variant="subheading">{localizations.common.announcementCount} {this.props.company.announcementCount}</Typography>
        <CompanyActivityMark isCompany={false} level={this.props.company.announcementCount} />
    </Grid>
    <Grid container justify="center" alignItems="center" style={{marginTop: "10px"}}>
        <ZeckitSmallWidget businessId={this.props.company.businessId} maxWidth={32} />
    </Grid>
</Grid> */}


type TruckCardProps = TruckRouteProps & GoToDetails;

class TruckCard extends React.Component<TruckCardProps,{}> {
    constructor(props: TruckCardProps) {
        super(props);
    }

    public render() {
        return (
            <Grid container direction="column">
                <Grid item>
                    <Grid container direction="row" spacing={2}>
                        <Grid item xs={6}>
                            <Grid container direction="column">
                                <Grid item>
                                    <Typography paragraph variant="subtitle1">{localizations.trucks.truckDetailsHeader}</Typography>
                                </Grid>
                                <Grid item>
                                    <TruckCardTitle {...this.props} />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={6}>
                            <Grid container direction="column">
                                <Grid item>
                                    <Typography paragraph variant="subtitle1">{localizations.trucks.companyDetailsHeader}</Typography>
                                </Grid>
                                <Grid item>
                                    <TransportCoordinatorInfo {...this.props} />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} style={{ marginBottom: 10 }}>
                    <table>
                        <tbody>
                            <tr>
                                <td className="title" style={{ verticalAlign: "top" }}>
                                    {localizations.common.details}:
                                </td>
                                <td style={{ wordWrap: "break-word", wordBreak: "break-all" }}>
                                    {this.props.details}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </Grid>
                <Grid item>
                    <Grid container direction="row" justify="flex-end">
                        <Grid item>
                            <Tooltip title={localizations.common.showOnTable}>
                                <IconButton style={{ height: 32, width: 32 }} onClick={() => this.props.onGoToTable(this.props)}><img src={listImg} width='16' height='16' /></IconButton>
                            </Tooltip>
                        </Grid>
                        <Grid item style={{paddingLeft: 16}}>
                            <Tooltip title={localizations.actions.sendInfoByEmail}>
                                <IconButton style={{ height: 32, width: 32 }} onClick={() => this.props.onSendEmail(this.props)}><img src={forwardImg} width='16' height='16' /></IconButton>
                            </Tooltip>
                        </Grid>
                        <Grid item style={{paddingLeft: 16}}>
                            <Tooltip title={localizations.actions.sendEmailToReporter}>
                                <IconButton style={{ height: 32, width: 32 }} onClick={() => this.props.onSendEmailToReporter(this.props)}><img src={emailImg} width='16' height='16' /></IconButton>
                            </Tooltip>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = (state: ApplicationState) => {
    const { trucks } = state;
    return { trucks };
}


export default connect<any, any, any>(mapStateToProps)(TruckCard);


// WEBPACK FOOTER //
// ./src/map/TruckCard.tsx